import { Component } from "react"
import PropTypes from "prop-types"

import ServiceCard from "shared/components/service_card.js"
import { serviceShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

class GetMoreServiceCard extends Component {
  handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "discover",
      object_id: this.props.service.module_name,
      object_type: "service",
      position: this.props.position,
      service_numeric_id: this.props.service.id,
    })
  }

  render() {
    return (
      <li
        ref={el => {
          this.scrollObserverEl = el
        }}
        className="service-card-list-item"
      >
        <ServiceCard
          service={this.props.service}
          onClick={this.handleOnClick}
          path={`/${this.props.service.module_name}`}
        />
      </li>
    )
  }
}

GetMoreServiceCard.propTypes = {
  service: serviceShape.isRequired,
  position: PropTypes.number.isRequired,
}

GetMoreServiceCard.defaultProps = {
  service: {},
}

export default GetMoreServiceCard
